import { empty } from 'views/components/php.js';

function decode_elementos_correo(elementos = {}) {
    if (empty(elementos)) {
        return {
            saludo: 'Buen día. Le envío la cotización para su mudanza de acuerdo al inventario y detalle que nos proporcionó.',
            slogan1: 'Nuestro servicio considera la protección de sus muebles con colchoneta y plástico adherible (playo).',
            slogan2: '¡Estamos listos para ayudarle!'
        };
    }

    return JSON.parse(elementos);
}

function get_cotizacion_vacia() {
    return {
        id_mm: '',
        id_crm: '',
        clave: 0,
        num_calculo: 0,
        precio: '',
        horas: 2,
        ayudantes: 1,
        vehiculo: 'Camioneta de 1.5 Ton, caja cerrada, 12 m3',
        nota_adicional: null,
        elementos_correo: decode_elementos_correo(),
        archivos_adjuntos: [],
        enviado_correo: 0,
        cotizacion_pdf: '',
        fecha_creacion: null
    };
}

function decode_cotizacion(cot = {}) {
    if (empty(cot)) {
        return get_cotizacion_vacia();
    }

    cot.elementos_correo = decode_elementos_correo(cot.elementos_correo);
    cot.archivos_adjuntos = JSON.parse(cot.archivos_adjuntos);
    return cot;
}

export {
    decode_cotizacion,
    get_cotizacion_vacia
};
